import { createDataStore } from "./common";

export default createDataStore({
  storeKey: "tags",
  endpoint: process.env.REACT_APP_PLACES_API_HOST + "/tags",
  idKey: "mn_tag_id"
});
